import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    smsOptIn: false,
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Starting form submission...', formData);
    setIsSubmitting(true);

    try {
      console.log('Attempting to add document to Firestore...');
      // Save to Firestore 'messages' collection
      const docRef = await addDoc(collection(db, "messages"), {
        ...formData,
        createdAt: serverTimestamp()
      });
      console.log('Document successfully added with ID:', docRef.id);

      alert('Thank you for contacting us! Your message has been saved.');
      setFormData({ name: '', email: '', phone: '', smsOptIn: false, message: '' });
    } catch (error) {
      console.error("Error adding document to Firestore:", error);
      alert(`Oops! Something went wrong: ${error.message}`);
    } finally {
      console.log('Form submission sequence complete.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-us">
      <section className="contact-info">
        <h2>Get in Touch</h2>
        <div className="contact-content">
          <p className="contact-text">
            Have questions? Want to discuss your next project? Drop us a line, and let's make magic happen!
          </p>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                value={formData.name} 
                onChange={handleChange} 
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input 
                type="tel" 
                id="phone" 
                name="phone" 
                value={formData.phone} 
                onChange={handleChange} 
                placeholder="123-456-7890"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">How can we help?</label>
              <textarea 
                id="message" 
                name="message" 
                value={formData.message} 
                onChange={handleChange} 
                rows="4"
              ></textarea>
            </div>

            <div className="form-group checkbox-group">
              <input 
                type="checkbox" 
                id="smsOptIn" 
                name="smsOptIn" 
                checked={formData.smsOptIn} 
                onChange={handleChange} 
              />
              <label htmlFor="smsOptIn" className="checkbox-label">
                I agree to receive automated marketing text messages from Hive Hub at the phone number provided. 
                Consent is not a condition of purchase. Message and data rates may apply. Message frequency varies. 
                Reply STOP to cancel, HELP for help. See our <Link to="/terms">Terms of Service</Link> and <Link to="/privacy">Privacy Policy</Link>.
              </label>
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>

          <div className="contact-details">
            <p>Email: <a href="mailto:g.nunez.2803@gmail.com">g.nunez.2803@gmail.com</a></p>
          </div>
        </div>
      </section>
...    </div>
  );
};

export default ContactUs;
